import { DatePipe } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { FormSessionCanDeactivate, PatientService, UserService } from '../../shared';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-addpartner',
  templateUrl: './addpartner.component.html',
  styleUrls: ['./addpartner.component.css']
})
export class AddpartnerComponent extends FormSessionCanDeactivate {

  @ViewChild('ca') myForm: NgForm;
  caredataimg: any;
  public data: Object;
  setlength: any;
  setlength1: any;
  public defaultUl = './assets/img/users/addusericon.png'
  dateformat: any;
  setmask: any;
  setmask1: any;
  maxlen: any;
  maxlen1: any;
  showloader: boolean = false;
  ffar: string = '';
  i: any = 0;
  currentUser: any;
  public Patpro: any = {
    gender: "",
    onBehalf: false,
    code: '+1' + ',' + 'USA',
    relationship: ""
  };
  alterNo: any;
  hospitalid: any;
  patid: any;
  public imgMaxSize = environment.imagefileSize;
  imageURL: any;
  tempphone: any;
  temMail: any;
  tempphoneOther: any;
  public addcarepost: Object;
  public codes: any = [];
  defaultimg: boolean = true;
  terms: number = 0;
  careimagearr;
  Catprofile: any;
  defaultmyimg: any;
  resdata: any;
  public timealert = environment.timelimit;
  apiurl: any = environment.api_url;
  bsConfig: any;
  modalRef: BsModalRef;
  modalRef1: BsModalRef;
	prefLang: string = '';
  languageConfig = {
		"multiLanguageRequired" : false,
		"languages": []
	}
  languageSubscription: Subscription;
  disableLang = false;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
    this.movable()
  }

  constructor(
    private router: Router,
    private Userservice: UserService,
    private modalService: BsModalService,
    private patientservice: PatientService,
    private toast: ToastrService,
    private Datepipe: DatePipe
  ) {
    super();
    this.prefLang = this.Userservice.LoginDefaultLanguage;
  };

  ngOnInit() {
    this.Userservice.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        if (this.currentUser.item) {
          if (this.currentUser.item.language != 'en_uk') {
            this.Patpro.code = '+1,USA'
            this.Patpro.codeOther = '+1,USA'
          } else if (this.currentUser.item.language == 'en_uk') {
            this.Patpro.code = '+44,UK'
            this.Patpro.codeOther = '+44,UK'
          }
          if (this.currentUser.item.clientTeleCode) {
            this.Patpro.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
            this.Patpro.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
          }
          this.setmask = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
          this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
          this.checkphonelength(this.Patpro.code, 0)
          this.checkphonelength1(this.Patpro.codeOther, 0)
          if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
          } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
          }
          this.tempCode = this.Patpro.code
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
          this.hospitalid = this.currentUser.item.userAccountKey;
          if (this.currentUser.item && this.currentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;

          this.getPreferredLanguage();
        }
      }
    )


    ////console.log("id", this.hospitalid)
    this.getselect();
    this.getalter()
    if (window.localStorage['careDetails']) {
      this.patid = JSON.parse(atob(window.localStorage['careDetails']))
    }

    if (this.patid.partnerstatus == 'new') {
      this.Patpro.cpEmailValid = true;
      this.Patpro.cpPhoneValid = true;
    }

    if (this.patid.partnerstatus != 'new' && this.patid.uid) {
      this.Patpro.cpEmailValid = true;
      this.Patpro.cpPhoneValid = true;
      this.Userservice
        .getcarepartnerdetails(this.patid.uid, this.patid.patientId)
        .subscribe(
          data => {
            for (var i = 0; i < data.length; i++) {
              this.Patpro = data[i];
              this.disableLang = true;      //to Disable the Pref Language dropdown change When already added User
              if (this.Patpro.phone) {
                this.tempphone = this.Patpro.phone
                this.Patpro.code = this.Patpro.teleCode + ',' + this.Patpro.teleCountryCode
              }
              else {
                if (this.currentUser.item.language != 'en_uk') {
                  this.Patpro.code = '+1,USA'
                } else if (this.currentUser.item.language == 'en_uk') {
                  this.Patpro.code = '+44,UK'
                }
                if (this.currentUser.item.clientTeleCode)
                  this.Patpro.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
              }
              this.temMail = data[i].email;
              this.checkphonelength(this.Patpro.code, 0)
              if (this.Patpro.phoneOther) {
                this.tempphoneOther = this.Patpro.phoneOther
                this.phoneOthervalue = true
                this.Patpro.codeOther = this.Patpro.teleCodeOther + ',' + this.Patpro.teleCountryCodeOther
              }
              else {
                this.phoneOthervalue = false
                if (this.currentUser.item.language != 'en_uk') {
                  this.Patpro.codeOther = '+1,USA'
                } else if (this.currentUser.item.language == 'en_uk') {
                  this.Patpro.codeOther = '+44,UK'
                }
                this.Patpro.otherPhoneType = 1
                if (this.currentUser.item.clientTeleCode)
                  this.Patpro.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
              }
              this.checkphonelength1(this.Patpro.codeOther, 0)

              this.prefLang = this.Patpro?.preferredLanguage || this.Userservice.LoginDefaultLanguage;
                setTimeout(() => {
                  const cnDropElement = document.getElementById("multilang") as HTMLSelectElement;
                  if (cnDropElement) {
                    cnDropElement.value = this.prefLang;
                  }
                }, 500);
            }
            if (data[0].imagePath) {
              this.defaultimg = false;
              this.defaultmyimg = true;
              if (data[0].imagePath.search("default_") == -1)
                this.caredataimg = this.imageURL + data[0].imagePath;
              else
                this.caredataimg = this.defaultUl

            }
            this.Catprofile = JSON.parse(JSON.stringify(this.Patpro))
            this.tempCode = this.Patpro.code
            // this.caredataimg = this.apiurl + data[0].imagePath;
            // //////console.log(data[0].imagePath);
          }

        );
    }
    //////console.log('id ' + this.patid.patientId);
    //////console.log('id ' + this.patid.patientName);
    //////console.log('id ' + this.patid.patientSWFId);
    //this.Patpro.gender="choose...";
  }
  getselect() {
    let self = this;
    self.patientservice.getselcode(this.hospitalid)
      .subscribe(data => {
        self.codes = data

      })
  }
  getalter() {
    let self = this;
    self.patientservice.getAlterNo()
      .subscribe(data => {
        self.alterNo = data
        self.Patpro.otherPhoneType = 1
      })
  }
  // addtermschange(){
  //     if(this.terms === )
  //     {
  //       this.terms = "true";
  //     }
  //     else
  //     {
  //       this.terms = 0;
  //     }
  //     //////console.log("terms" + this.terms);
  // }

  // checkphonlength(e) {
  //   if (e) {
  //     let telecode = e.split(',')
  //     let codecoun = telecode[1]
  //     this.userService.phonebycountrycode(codecoun)
  //       .subscribe(
  //         data => {
  //           this.setlength = data.Length;
  //           this.maxlen = data.Length + this.currentUser.item.length;
  //           this.Patpro.cpPhoneValid = true;

  //         }
  //       );
  //   }
  // }

  checkphonelength(e, k) {
    if (k != 0) {
      this.Patpro.phone = "";
    }

    let telecode = e.split(',')
    let codecoun = telecode[1]
    this.Userservice.phonebycountrycode(codecoun)
      .subscribe(
        data => {
          let self = this
          self.setlength = data.Length;
          self.maxlen = data.Length + self.currentUser.item.length;
          if (data.Length == 11) {
            self.setmask = self.currentUser.item.phoneFormat.split('#').join('0').concat('0')
          } else {
            self.setmask = self.currentUser.item.phoneFormat.split('#').join('0')
          }
        }
      );
  }

  j: any;
  checkphonelength1(e, k) {
    if (k != 0) {
      this.Patpro.phoneOther = "";
    }
    this.j++;
    let telecode = e.split(',')
    let codecoun = telecode[1]
    this.Userservice.phonebycountrycode(codecoun).subscribe(
      data => {
        this.setlength1 = data.Length;
        this.maxlen1 = data.Length + this.currentUser.item.length;
        if (data.Length == 11) {
          this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0').concat('0')
        } else {
          this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0')
        }
      }
    );
  }

  checkphonlength1(e) {
    let code = this.Patpro.code.split(',')
    let codeOther = this.Patpro.codeOther.split(',')
    if (code[0] + this.Patpro.phone == codeOther[0] + this.Patpro.phoneOther && this.Patpro.phone) {
      this.toast.error(this.Userservice.translateText('hospital_portal.disp_messages.mob_no_should_not_same.error'), '', {
        timeOut: this.timealert
      })
      return this.Patpro.phoneOther = ''
    }
  }

  checkphonlength(e) {
    if ((this.Patpro.phone.length < this.setlength && this.Patpro.phone != '') || this.Patpro.phone == '(')
      this.btndisable = true
    else
      this.btndisable = false
    let code = this.Patpro.code.split(',')
    let codeOther = this.Patpro.codeOther.split(',')
    if (code[0] + this.Patpro.phone == codeOther[0] + this.Patpro.phoneOther && this.Patpro.phone) {
      this.toast.error(this.Userservice.translateText('hospital_portal.disp_messages.mob_no_should_not_same.error'), '', {
        timeOut: this.timealert
      })
      return this.Patpro.phone = ''
    }

  }
  addcareimgurl(event) {
    let acceptFormat = ['image/png', 'image/x-png', 'image/jpeg', 'image/jpg']
    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (events: any) => {
      let self = this
      if (!acceptFormat.includes(event.target.files[0].type)) {
        self.toast.error(this.Userservice.translateText('patient_portal.validations.file_not_allowed.error_label'), '', {
          timeOut: self.timealert
        })
        // self.myInputVariable.nativeElement.value = "";
        self.defaultimg = true;
        self.defaultmyimg = false;
        self.caredataimg = self.defaultimg;
        return;
      }
      if (event.target.files[0].size >= self.imgMaxSize) {
        self.toast.error(this.Userservice.translateText('patient_portal.validations.maximum_size_exceed.error_label'), '', {
          timeOut: self.timealert
        })
        // self.myInputVariable.nativeElement.value = "";
        self.defaultimg = true;
        self.defaultmyimg = false;
        self.caredataimg = self.defaultimg;
        return;
      } else {
        self.defaultimg = false;
        self.defaultmyimg = true;
        //////console.log("hidde" + self.defaultimg);
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (events: any) => {
          self.caredataimg = events.currentTarget.result; // base64
          //////console.log(event.target.files[0]);
          self.careimagearr = [{
            filename: event.target.files[0].name,
            filetype: event.target.files[0].type,
            value: events.currentTarget.result.split(',')[1]
          }];
          //////console.log(self.careimagearr);
        }



      }

    }
  }
  btndisable: boolean
  addcarepostfun(car, sucessda, userdetails) {
    this.btndisable = true
    if (this.checkPhoneClear && !this.duplicateshow)
      this.phonechange(car, sucessda)
    else if (this.checkEmailClear && !this.duplicateshow)
      this.emailchange(this.Patpro.email, car, sucessda)
    else
      this.savedetails(car, sucessda)

  }
  phonechange(car, sucessda) {
    let telecode: any;
    telecode = this.Patpro.code.split(',')
    this.mobile_val = telecode[0] + '-' + this.Patpro.phone;
    let temPhone = ''
    let tempcode = this.tempCode.split(',')
    if (this.tempphone) {
      temPhone = tempcode[0] + '-' + this.tempphone
    }
    //this.mobile_val = event.target?event.target.value:
    if (this.Patpro.phone) {
      let data = {
        "oldEmail": '',
        "newEmail": '',
        "oldPhone": temPhone,
        "newPhone": this.mobile_val,
        "addOrEdit": this.patid.partnerstatus != 'new' ? 'edit' : 'add',
        "updatingProfileRole": 20
      }
      this.getUserExist(data, this.currentUser.item.userAccountKey, car, sucessda)
    }
  }
  getUserExist(data, userAccountKey, car, sucessda) {
    this.patientservice.getUserExist(data, userAccountKey)
      .subscribe(data => {
        if ((data.popUpStatus == 'true' && data.status == 'success') || data.message == 'User already Exist') {
          this.btndisable = false;
          return;
        }
        else {
          this.savedetails(car, sucessda)
        }
      })
  }

  emailchange(event, car, sucessda) {
    this.email_val = event ? event : this.Patpro.email;
    var special = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
    if (this.email_val && this.email_val.match(special)) {
      let self = this;
      let data = {
        "oldEmail": self.temMail ? self.temMail : '',
        "newEmail": self.Patpro.email,
        "oldPhone": '',
        "newPhone": '',
        "addOrEdit": this.patid.partnerstatus != 'new' ? 'edit' : 'add',
        "updatingProfileRole": 20
      }
      this.getUserExist(data, this.currentUser.item.userAccountKey, car, sucessda)
    }
  }
  savedetails(car, sucessda) {

    if ((car.value.phone.length < this.setlength && car.value.phone != '') || car.value.phone == '(') {
      this.btndisable = true
      return
    }

    if (this.updatedProfile == 'updated' || this.updatedProfile == 'update') {
      this.modalRef = this.modalService.show(sucessda, { class: 'modal-sm', backdrop: 'static' });
      this.movable()
      this.resdata = this.Userservice.translateText('hospital_portal.disp_messages.want_to_change_profile.label');
    } else {
      if (this.patid.partnerstatus != "new") {
        this.editcare(car, sucessda)
      } else {
        this.showloader = true;
        car.value.uploadimage = this.careimagearr;
        if (this.careimagearr == undefined) {
          car.value.uploadimage = [{}];
        }
        if (car.value.phone == undefined) {
          car.value.phone = ""
        }
        if (car.value.phoneOther == undefined) {
          car.value.phoneOther = ""
        }
        if (!car.value.email) {
          car.value.email = ""
        }
        if (car.value.phone) {
          let telecode = car.value.code.split(',')
          car.value.teleCode = telecode[0]
          car.value.teleCountryCode = telecode[1]
        }
        else {
          car.value.teleCode = ""
          car.value.teleCountryCode = ""
        }
        if (car.value.phoneOther) {
          let telecode = car.value.codeOther.split(',')
          car.value.teleCodeOther = telecode[0]
          car.value.teleCountryCodeOther = telecode[1]
        }
        else {
          car.value.teleCodeOther = ""
          car.value.teleCountryCodeOther = ""
        }
        if (!car.value.otherPhoneType) {
          car.value.otherPhoneType = ''
        }
        //////console.log(car.value);
        let TakenBy = this.currentUser.item.userAccountId
        if (window.localStorage['superClientId'])
          TakenBy = window.localStorage['superClientId']
        let msgvalue = {
          "email": car.value.email,
          "firstName": car.value.firstName,
          "gender": car.value.gender,
          "lastName": car.value.lastName,
          "onBehalf": car.value.onBehalf,
          "teleCountryCode": car.value.teleCountryCode,
          "teleCode": car.value.teleCode,
          "phone": car.value.phone,
          "otherPhoneType": car.value.otherPhoneType,
          "teleCountryCodeOther": car.value.teleCountryCodeOther,
          "teleCodeOther": car.value.teleCodeOther,
          "phoneOther": car.value.phoneOther,
          "relationship": car.value.relationship,
          "uploadimage": car.value.uploadimage,
          "patientId": this.patid.patientId,
          "takenBy": TakenBy,
          "preferredLanguage": this.prefLang || this.Userservice.defaultLang
        }
        ////console.log("det", msgvalue);
        this.patientservice
          .getcarepart(msgvalue)
          .subscribe(
            data => {
              this.showloader = false;
              this.btndisable = false
              //////console.log(data);

              if (data.message == "Email address already exists") {
                this.ffar = this.Userservice.translateText('patient_portal.validations.email_already_exist.error_label')
                //this.modalRef = this.modalService.show(sucessda, {class: 'modal-sm'});

              }

              else if (data.message) {
                this.ffar = "";
                car.reset();
                this.resdata = data.message;
                this.modalRef = this.modalService.show(sucessda, { class: 'modal-sm', backdrop: 'static' });
                this.Userservice.logAudit('getSummaryaddcarepartner', '').subscribe(data => { })
                this.movable()
              } else {
                this.ffar = this.Userservice.translateText('hospital_portal.disp_messages.enter_valid_data.error');
              }



            }

          );
      }
    }
  }
  editcare(ed, temppassword) {
    this.showloader = true;

    ed.value.uploadimage = this.careimagearr;
    if (this.careimagearr == undefined) {
      ed.value.uploadimage = [{}];
    }
    if (ed.value.phone == undefined || ed.value.phone == "") {
      ed.value.phone = ""
      ed.value.teleCode = ""
      ed.value.teleCountryCode = ""
    }
    else {
      let telecode = ed.value.code.split(',')
      ed.value.teleCode = telecode[0]
      ed.value.teleCountryCode = telecode[1]
    }
    if (ed.value.phoneOther == undefined || ed.value.phoneOther == "") {
      ed.value.phoneOther = ""
      ed.value.teleCodeOther = ""
      ed.value.teleCountryCodeOther = ""
    }
    else {
      let telecode = ed.value.codeOther.split(',')
      ed.value.teleCodeOther = telecode[0]
      ed.value.teleCountryCodeOther = telecode[1]
    }
    if (!ed.value.otherPhoneType) {
      ed.value.otherPhoneType = ""
    }
    //////console.log(ed.value);
    ed.value["preferredLanguage"] = this.prefLang;
    this.Userservice.updatecarpa(this.patid.uid, this.patid.patientSWFId, ed.value)
      .subscribe(
        data => {


          //////console.log(data);
          this.showloader = false;
          if (data.saveStatus == 'false') {
            this.ffar = data.message;
            //this.resdata = "Email Id already exists";
            //this.modalRef = this.modalService.show(sucessda, {class: 'modal-sm'});

          } else if (data.saveStatus == 'false' && data.message == "Email address already exists!") {
            this.ffar = this.Userservice.translateText('patient_portal.display_messages.email_already_exists.error') + "!";
            //this.resdata = "Email Id already exists";
            //this.modalRef = this.modalService.show(sucessda, {class: 'modal-sm'});

          } else if (data.saveStatus == "true") {
            this.ffar = "";
            ed.reset();
            this.Userservice.logAudit("updatecarepartner", '').subscribe(data => { })
            this.resdata = this.Userservice.translateText('hospital_portal.disp_messages.care_partner_updated.success')+ "!!";
            this.modalRef = this.modalService.show(temppassword, { class: 'modal-sm', backdrop: 'static' });
          } else {
            //this.ffar = "Update Successfully";
            this.resdata = this.Userservice.translateText('hospital_portal.disp_messages.care_partner_updated.success');
            this.modalRef = this.modalService.show(temppassword, { class: 'modal-sm', backdrop: 'static' });

          }
        }
      );
  }
  getdate(date) {
    if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
      return this.Datepipe.transform(date, environment.dateForm);
    } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
      return this.Datepipe.transform(date, 'dd/MM/yyyy');
    }
  }



  refresh() {
    if (this.modalRef)
      this.modalRef.hide();
    this.Patpro = {
      gender: "",
      onBehalf: false,
      code: '+1' + ',' + 'USA',
      relationship: ""
    };
    if (!window.localStorage['patDetails']) {
      let patDetails = {
        'patientId': this.patid.patientId,
        'patientSWFId': this.patid.patientSWFId,
        'patstatus': this.patid.patstatus,
        'status': this.patid.status
      }
      window.localStorage['patDetails'] = btoa(JSON.stringify(patDetails))
    }
    this.router.navigate([`/care/patientdetails`])
  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }
  // addcaregender = ['Male', 'Female'];
  relationships = ['Spouse', 'Child', 'Parent', 'Other Family', 'Non-Family', 'Friend', 'Professional Caregiver', 'Unknown'];


  //////////////// model change
  getEmaildata: any;
  email_val: any;
  onSelection(event, userdetails) {
    this.email_val = event ? event.target.value : this.Patpro.email;
    var special = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
    if (this.email_val && this.email_val.match(special)) {
      let self = this;
      let data = {
        "oldEmail": self.temMail ? self.temMail : '',
        "newEmail": self.Patpro.email,
        "oldPhone": '',
        "newPhone": '',
        "addOrEdit": this.patid.partnerstatus != 'new' ? 'edit' : 'add',
        "updatingProfileRole": 20
      }
      self.patientservice.getUserExist(data, this.currentUser.item.userAccountKey)
        .subscribe(data => {
          if (data.status == 'success') {
            if (data.popUpStatus == 'true') {
              this.Userservice.getuserdetails(self.Patpro.email)
                .subscribe(data => {
                  if (data.firstName) {
                    self.getEmaildata = data
                    if (((!this.Patpro.firstName && !this.Patpro.lastName) || ((data.firstName != this.Patpro.firstName) || (data.lastName != this.Patpro.lastName)))) {
                      if (!this.modalRef1 || !this.modalRef1.content) {
                        this.modalRef1 = this.modalService.show(userdetails, {
                          class: 'modal-md',
                          backdrop: 'static'
                        })
                      }
                      //this.movable();

                    }
                  }
                });
              return false;
            }
          } else if (self.Patpro.email) {
            self.Patpro.email = ""
            if (!this.alertShowed) {
              self.toast.error('Email address already exist', '', {
                timeOut: this.timealert
              })
              this.alertShowed = true;
            }
            this.checkEmailClear = false
            return false;
          }
        });
    }
    else {
      return true;
    }

  } //////////////// model change
  mobile_val: any;
  valueChange: number = 0
  onSelection1(event, userdetails) {
    let telecode: any;
    telecode = this.Patpro.code.split(',')
    this.mobile_val = telecode[0] + '-' + this.Patpro.phone;
    let temPhone = ''
    let tempcode = this.tempCode.split(',')
    if (this.tempphone) {
      temPhone = tempcode[0] + '-' + this.tempphone
    }
    //this.mobile_val = event.target?event.target.value:
    if (this.Patpro.phone) {
      let self = this;
      let data = {
        "oldEmail": '',
        "newEmail": '',
        "oldPhone": temPhone,
        "newPhone": this.mobile_val,
        "addOrEdit": this.patid.partnerstatus != 'new' ? 'edit' : 'add',
        "updatingProfileRole": 20
      }
      self.patientservice.getUserExist(data, this.currentUser.item.userAccountKey)
        .subscribe(data => {
          if (data.status == 'success') {
            if (data.popUpStatus == 'true') {
              this.Userservice.getuserdetails(this.mobile_val)
                .subscribe(data => {
                  if (data.firstName) {
                    self.getEmaildata = data
                    if (((!this.Patpro.firstName && !this.Patpro.lastName && !this.Patpro.email) || ((data.firstName != this.Patpro.firstName) || (data.lastName != this.Patpro.lastName) || (data.email != this.Patpro.email)))) {
                      if (!this.modalRef1 || !this.modalRef1.content) {
                        this.modalRef1 = this.modalService.show(userdetails, {
                          class: 'modal-md',
                          backdrop: 'static'
                        });
                      }
                      //this.movable();

                    }
                    ////console.log("getEmaildata", data)
                  }
                });
              return false;
            }
          } else if (this.Patpro.phone) {
            this.Patpro.phone = ""

            if (!this.alertShowed) {
              this.toast.error(this.Userservice.translateText('hospital_portal.disp_messages.mob_already_exists.error'), '', {
                timeOut: this.timealert
              });
              this.alertShowed = true;
            }
            this.checkPhoneClear = false
            return false;
          }
        });
    }
    else {
      this.valueChange = this.valueChange + 1
      return true
    }
  }
  alertShowed: boolean;
  activate(template) {
    if (this.Patpro.onBehalf && !this.Patpro.email && !this.Patpro.phone) {
      this.modalRef1 = this.modalService.show(template, {
        class: 'modal-sm',
        backdrop: 'static'
      })
      this.movable();
    }
  }
  validateEmail(email) {

    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());

  }
  validatemail: any = false
  required: any = false
  checkEmail() {
    let self = this;
    if (self.Patpro.email) {
      let checkEmail = self.validateEmail(self.Patpro.email)

      if (checkEmail || self.Patpro.email == '') {
        self.validatemail = false
      } else if (!checkEmail && self.Patpro.email) {
        self.required = true;
        self.validatemail = true
        self.toast.error(this.Userservice.translateText('patient_portal.validations.enter_a_valid_email.error_label'), '', {
          timeOut: this.timealert
        })

      }
    }
  }
  updatedProfile: any = ''
  tempCode: any
  duplicateshow: any;
  selection(status) {
    this.modalRef1.hide()
    this.modalRef1 = undefined
    if (this.getEmaildata && status) {
      this.duplicateshow = true
      this.Patpro.firstName = this.getEmaildata.firstName;
      this.Patpro.email = this.getEmaildata.email ? this.getEmaildata.email : ''
      this.Patpro.phone = this.getEmaildata.phone;
      this.Patpro.phoneOther = this.getEmaildata.phoneOther;
      this.Patpro.otherPhoneType = this.getEmaildata.otherPhoneType ? this.getEmaildata.otherPhoneType : 1;
      this.Patpro.lastName = this.getEmaildata.lastName;
      this.Patpro.gender = this.getEmaildata.gender;
      this.Patpro.code = this.getEmaildata.teleCode + ',' + this.getEmaildata.teleCountryCode;
      this.Patpro.codeOther = this.getEmaildata.teleCodeOther + ',' + this.getEmaildata.teleCountryCodeOther;
      this.defaultimg = false;
      this.defaultmyimg = true;
      this.caredataimg = this.imageURL + this.getEmaildata.imagePath;
      this.Patpro.relationship = this.Patpro.relationship ? this.Patpro.relationship : ''
      if (this.getEmaildata.email) {
        this.Patpro.email = this.getEmaildata.email;
      }
      if (this.Patpro.phone) {
        this.checkphonelength(this.Patpro.code, 0)
      }
      if (this.Patpro.phoneOther) {
        this.checkphonelength1(this.Patpro.codeOther, 0)
      }
      if (!this.getEmaildata.teleCode) {
        if (this.currentUser.item.language != 'en_uk') {
          this.Patpro.code = '+1,USA'
        } else if (this.currentUser.item.language == 'en_uk') {
          this.Patpro.code = '+44,UK'
        }
        if (this.currentUser.item.clientTeleCode)
          this.Patpro.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
      }
      if (!this.getEmaildata.teleCodeOther) {
        if (this.currentUser.item.language != 'en_uk') {
          this.Patpro.codeOther = '+1,USA'
        } else if (this.currentUser.item.language == 'en_uk') {
          this.Patpro.codeOther = '+44,UK'
        }
        if (this.currentUser.item.clientTeleCode)
          this.Patpro.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
      }
      this.updatedProfile = 'New'
      // this.caredataimg =this.getEmaildata.imgPath
    } else {
      this.Patpro.email = ''
      this.Patpro.phone = ''
      this.checkEmailClear = false
      this.checkPhoneClear = false
      this.Patpro.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
    }
  }

  OnchangeProfile() {
    if (this.updatedProfile == 'New') {
      this.updatedProfile = 'updated'
    }
  }

  phoneOthervalue: any = false
  viewalterno(phoneOthervalue) {
    if (!phoneOthervalue) {
      this.phoneOthervalue = true
      this.Patpro.otherPhoneType = 1
      this.changeAlterNo()
    }
  }


  checkPhoneClear: boolean;
  setPhoneValue: any;
  backupPhoneValue(event) {
    if (event) {
      this.checkPhoneClear = true;
      this.setPhoneValue = event;
      this.duplicateshow = false
      if (event.length < this.setlength || event == '(')
        this.btndisable = true
      else
        this.btndisable = false
    }
    else {
      this.checkPhoneClear = false;
      this.btndisable = false
    }

    // console.log("setPhoneValue",this.checkPhoneClear)
  }

  checkEmailClear: boolean;
  setEmailValue: any;
  backupEmailValue(event) {
    if (event) {
      this.checkEmailClear = true;
      this.setEmailValue = event;
      this.duplicateshow = false
    }
    else {
      this.checkEmailClear = false;
    }
    // console.log("setEmailValue",this.checkEmailClear)
  }

  changeAlterNo() {
    if (this.currentUser.item.language != 'en_uk') {
      this.Patpro.codeOther = '+1,USA'
    } else if (this.currentUser.item.language == 'en_uk') {
      this.Patpro.codeOther = '+44,UK'
    }
    if (this.currentUser.item.clientTeleCode) {
      this.Patpro.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
    }
    this.Patpro.phoneOther = ''
  }

  // setEmailorPhoneValidation(valuechange,event){
  //   console.log("event",event);
  //   if(event && !this.Patpro.email && !this.Patpro.phone){
  //     this.myForm.form.get('email').setValidators([Validators.required]);
  //     this.myForm.form.get('email').setValidators([Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
  //     this.myForm.form.get('email').updateValueAndValidity();

  //     this.myForm.form.get('phone').setValidators([Validators.required]);
  //     this.myForm.form.get('phone').updateValueAndValidity();
  //   }else if(valuechange && !event){
  //     this.myForm.form.get('email').clearValidators();
  //     this.myForm.form.get('email').updateValueAndValidity();
  //     this.myForm.form.get('phone').clearValidators();
  //     this.myForm.form.get('phone').updateValueAndValidity();
  //   }
  // }

  setEmailorPhoneValidation(event) {
    console.log("event", event);
    if (event && !this.Patpro.email && !this.Patpro.phone) {
      this.myForm.form.get('email').setValidators([Validators.required]);
      this.myForm.form.get('email').setValidators([Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
      this.myForm.form.get('email').updateValueAndValidity();

      this.myForm.form.get('phone').setValidators([Validators.required]);
      this.myForm.form.get('phone').setValidators([Validators.minLength(this.setlength), Validators.maxLength(this.maxlen)]);
      this.myForm.form.get('phone').updateValueAndValidity();
    }
    else if (event && this.Patpro.email) {
      this.myForm.form.get('email').setValidators([Validators.required]);
      this.myForm.form.get('email').setValidators([Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
      this.myForm.form.get('email').updateValueAndValidity();
      this.myForm.form.get('phone').setValidators([Validators.required]);
      this.myForm.form.get('phone').setValidators([Validators.minLength(this.setlength), Validators.maxLength(this.maxlen)]);
    }
    else if (event && this.Patpro.phone) {
      this.myForm.form.get('email').clearValidators();
      this.myForm.form.get('email').updateValueAndValidity();

      this.myForm.form.get('phone').setValidators([Validators.required]);
      this.myForm.form.get('phone').setValidators([Validators.minLength(this.setlength), Validators.maxLength(this.maxlen)]);
      this.myForm.form.get('phone').updateValueAndValidity();
    }
    else {
      this.myForm.form.get('email').clearValidators();
      this.myForm.form.get('email').setValidators([Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
      this.myForm.form.get('email').updateValueAndValidity();
      this.myForm.form.get('phone').clearValidators();
      this.myForm.form.get('phone').setValidators([Validators.minLength(this.setlength), Validators.maxLength(this.maxlen)]);
      this.myForm.form.get('phone').updateValueAndValidity();
    }
  }

  ngOnDestroy() {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

  getPreferredLanguage() {
		let targetEmail;
		if (this.currentUser && this.currentUser?.item?.email) {
			targetEmail = this.currentUser?.item?.email
		} 

		const credential = {
		  'userName': !targetEmail ? this.currentUser?.item?.clientTeleCode.replace("+",'') + "-" + this.currentUser?.item?.phone : targetEmail
		}
		this.languageSubscription = this.Userservice.getLanguageConfig(credential).subscribe(
		  langConfigRes => {
        if(langConfigRes && langConfigRes.hasOwnProperty("multiLanguageRequired")) {
          this.languageConfig = langConfigRes;
        }
		});
	}
}
